<div
    #serviceOverviewFilterView
    class="service-overview-filter__view"
    [class.service-overview-filter__view--fixed]="isFilterFixed"
    [class.service-overview-filter__view--mobile]="commonService.isMobile()">
    @if (hasFilterOptions()) {
        @if (!commonService.isMobile()) {
            <div class="service-overview-filter__section dynamic__padding--xs">
                <span class="service-overview-filter__section__title dynamic__text--xs">Region</span>

                <dynamo-list-menu
                    class="service-overview-filter__list"
                    [multiSelect]="true"
                    [listMenuLayout]="commonService.isMobile(1000) ? 'row' : 'column'"
                    [defaultOptions]="getCitiesKeys()"
                    [defaultOptionsChangeOverride]="true"
                    [listMenuConfig]="{
                        listMenuOptions: citiesItems,
                    }"
                    (selectedOptionsChange)="setSelectedCities($event)">
                </dynamo-list-menu>
            </div>

            <div class="service-overview-filter__section dynamic__padding--xs">
                <span class="service-overview-filter__section__title dynamic__text--xs">Kategorien</span>

                <dynamo-list-menu
                    class="service-overview-filter__list"
                    [multiSelect]="true"
                    [listMenuLayout]="commonService.isMobile(1000) ? 'row' : 'column'"
                    [defaultOptions]="getServiceTypeKeys()"
                    [defaultOptionsChangeOverride]="true"
                    [listMenuConfig]="{
                        listMenuOptions: serviceTypeItems,
                    }"
                    (selectedOptionsChange)="setSelectedServiceTypes($event)">
                </dynamo-list-menu>
            </div>
        } @else {
            <drag-scroll
                #dragScrollComponent
                class="service-overview-filter__drag-area dynamic__stretch--width dynamic__position--relative"
                [draggable]="!commonService.IsPlatformFirefox()"
                [scrollbar-hidden]="true"
                (indexChanged)="this.index = $event">
                <div class="service-overview-filter__drag-area__items dynamic__margin--none">
                    <span
                        class="service-overview-filter__section__title service-overview-filter__drag-area__items__title dynamic__text--xs">
                        Region
                    </span>

                    <dynamo-list-menu
                        class="service-overview-filter__drag-area__items__item"
                        listMenuLayout="row"
                        [multiSelect]="true"
                        [defaultOptionsChangeOverride]="true"
                        [defaultOptions]="getCitiesKeys()"
                        [listMenuConfig]="{
                            listMenuOptions: citiesItems,
                        }"
                        (selectedOptionsChange)="setSelectedCities($event)">
                    </dynamo-list-menu>

                    <span
                        class="service-overview-filter__section__title service-overview-filter__drag-area__items__title dynamic__text--xs">
                        Kategorien
                    </span>

                    <dynamo-list-menu
                        class="service-overview-filter__drag-area__items__item"
                        listMenuLayout="row"
                        [multiSelect]="true"
                        [defaultOptionsChangeOverride]="true"
                        [defaultOptions]="getServiceTypeKeys()"
                        [listMenuConfig]="{
                            listMenuOptions: serviceTypeItems,
                        }"
                        (selectedOptionsChange)="setSelectedServiceTypes($event)">
                    </dynamo-list-menu>
                </div>
            </drag-scroll>
            <div class="service-overview-filter__scroll">
                <div
                    class="service-overview-filter__scroll__progress"
                    [style.width]="
                        this.calculateScrollPercentage(dragScrollComponent._contentRef.nativeElement).toFixed(0) + '%'
                    "></div>
            </div>
        }
    } @else {
        <div class="service-overview-filter__no-option dynamic__padding--xs">
            <span class="dynamic__text--xs">Kein Filter verfügbar</span>
        </div>
    }
</div>
